export default __webpack_public_path__ + "static/content-85681edf9dfda935db9ffacd25a09238.jpg";